/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Tlm_0Inputs */

const en_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coverage`)
};

const ar_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغطية`)
};

const bn_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কভারেজ`)
};

const de_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdeckung`)
};

const es_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura`)
};

const fr_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture`)
};

const pt_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura`)
};

const zh_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖`)
};

const tr_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsam`)
};

const ru_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покрытие`)
};

const pl_svc_retainer_tlm_0 = /** @type {(inputs: Svc_Retainer_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokrycie`)
};

/**
* | output |
* | --- |
* | "coverage" |
*
* @param {Svc_Retainer_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_tlm_0 = /** @type {((inputs?: Svc_Retainer_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_tlm_0(inputs)
	if (locale === "bn") return bn_svc_retainer_tlm_0(inputs)
	if (locale === "de") return de_svc_retainer_tlm_0(inputs)
	if (locale === "es") return es_svc_retainer_tlm_0(inputs)
	if (locale === "fr") return fr_svc_retainer_tlm_0(inputs)
	if (locale === "pt") return pt_svc_retainer_tlm_0(inputs)
	if (locale === "zh") return zh_svc_retainer_tlm_0(inputs)
	if (locale === "tr") return tr_svc_retainer_tlm_0(inputs)
	if (locale === "ru") return ru_svc_retainer_tlm_0(inputs)
	if (locale === "pl") return pl_svc_retainer_tlm_0(inputs)
	return en_svc_retainer_tlm_0(inputs)
});